<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 59.1 (86144) - https://sketch.com -->
    <title>Icons/notifications/ic_alert_4</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <path
        id="path-1"
        d="M12,0 C5.376,0 0,5.376 0,12 C0,18.624 5.376,24 12,24 C18.624,24 24,18.624 24,12 C24,5.376 18.624,0 12,0 Z M13.2,18 L10.8,18 L10.8,15.6 L13.2,15.6 L13.2,18 Z M13.2,13.2 L10.8,13.2 L10.8,6 L13.2,6 L13.2,13.2 Z"
      ></path>
    </defs>
    <g
      id="Icons/notifications/ic_alert_4"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <mask id="mask-2" fill="white">
        <use xlink:href="#path-1"></use>
      </mask>
      <use id="icon/alert/error_24px" fill="#454545" xlink:href="#path-1"></use>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Alert",
}
</script>
